import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { ActionButtonsComponent } from '../../../../../components/kit/action-buttons/action-buttons.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { FormatPersonPipe } from '../../../pipes/format-person.pipe';

@Component({
    selector: 'app-input-select-entity',
    templateUrl: './input-select-entity.component.html',
    styleUrls: ['./input-select-entity.component.scss'],
    imports: [
        ActionButtonsComponent,
        FormatPersonPipe,
        SelectInputComponent,
        TranslatePipe,
    ],
})
export class InputSelectEntityComponent {
    private fb = inject(FormBuilder);

    @Input() options: Record<string, string | number>[] = [];
    @Input() valueKey = 'id';
    @Input() nameKey = 'name';
    @Input() noOptionsLabel = 'inputs.selectUserForm.noOptions';
    @Input() selectLabelPrefix = 'inputs.selectUserForm.';
    @Input() selectButtonLabel = 'inputs.select';
    @Input() cancelButtonLabel = 'inputs.cancel';
    @Output() entitySelectedEvent = new EventEmitter<string | number | null>();
    @Output() cancelEvent = new EventEmitter<void>();

    form = this.fb.group({
        entity: this.fb.control<number | string | null>(null),
    });

    submit() {
        this.entitySelectedEvent.emit(this.form.value.entity);
    }

    hide() {
        this.cancelEvent.emit();
    }
}
